export const firebaseConfig = {
  apiKey: "AIzaSyBzkbmB6kWtQG_xOhO8M7Scbf2Dk6pqqkw",
  authDomain: "pangea-458cd.firebaseapp.com",
  projectId: "pangea-458cd",
  storageBucket: "pangea-458cd.appspot.com",
  messagingSenderId: "39431836866",
  appId: "1:39431836866:web:30d6b1fa768b81798e175b",
  measurementId: "G-D5T00ZY5SG"
}

firebase.initializeApp(firebaseConfig)

export const analytics = firebase.analytics()

//After a specified time, close the warning/error alert aside
export const timedAlert = (callback = false, time = 3600) => {
  var alerts = document.querySelector('[data-feedback]')

  function animateOut(callback) { 
    alerts.classList.add('opacity-0')
    alerts.classList.remove('opacity-100')

    callback && callback()
  }

  if(alerts){
    //Reset the animator and the alert aside
    alerts.classList.add('opacity-100')
    alerts.classList.remove('opacity-0')

    if(callback){
      setTimeout(() => animateOut(callback), time)
    }else{
      setTimeout(() => animateOut(), time)
    }
  }else{
    return {
      feedback: {
        msgs: [{
          text: 'timedAlert called, but no alerts are available to close', 
          style: 'bg-poppy text-white'
        }]
      }
    }
  }
}

export const getPaths = () => {
  return window.location.pathname.split('/').map(path => path)
}

export const millsToMins = (mills) => {
  let minutes = Math.floor(mills/60000)
  let seconds = Math.round(mills/1000)
  return (seconds === 60 ? minutes+1 : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds) + mills
}

export const secondsToMins = (seconds) => {
  let mins = Math.floor(seconds*0.0166)
  mins = mins > 99 ? 99 : mins
  return (mins < 10 ? "0" + mins : mins) + ':' + seconds + ':00'
}

export const compareNames = (a, b) => {
  if (a.last_name < b.last_name)
      return -1;
  if (a.last_name > b.last_name)
      return 1;
  return 0;
}

export const postTracking = (user) => {
  const xhr = new XMLHttpRequest()
  let token = document.querySelector('meta[name="csrf-token"]')
      
  xhr.onload = () => {
    if (xhr.status == 200) {
      user.tracking = JSON.parse(xhr.response)
    } else {
      console.error('Error!')
    }
  }
  
  xhr.open('PUT', '/resource/tracking/'+user.tracking_id, true)

  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
  xhr.setRequestHeader('X-CSRF-TOKEN', token.content), 
  xhr.setRequestHeader('content-type', 'application/json')

  xhr.send(JSON.stringify(user.tracking))
}

export const trackIt = (event, user) => {
  let tracking = event.target.dataset.tracking
  if(tracking) analytics.logEvent(tracking)
  if(user) {
    let trackable = false

    Object.keys(user.tracking).map((evt) => {
      if(evt === tracking){
        trackable = evt
      }
    })

    if(trackable){
      user.tracking[trackable] += 1
      postTracking(user)
    }
  }
}

export const getError = () => {
  let error = document.querySelector('#error')
  return error ? error.value : false
}